import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Tools } from '../_shared/tools';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FileService {
  constructor(private http: HttpClient, public auth: AuthService, public tools: Tools) {}

  public uploadFile(file: FormData): Observable<any> {
    const header = new HttpHeaders({ Authorization: 'Bearer ' + this.auth.token });
    const options = { headers: header, reportProgress: true };
    const requestUrl = this.tools.buildUrl([environment.imageApiUrl]);
    const req = new HttpRequest('POST', requestUrl, file, options);
    return this.http.request(req);
  }
}
